import area from "./area";
import { EventBus } from "./eventbus.js";

export default {
  data() {
    return {
      value: "",
      options: [],
      forms: [],
      activeNames: "3",
      dialogVisible: false,
      currentForm: {},
      consultInfo: {},
      basicTableArray: [],
      shangjiaoTableArray: [],
      zhongjiaoTableArray: [],
      xiajiaoTableArray: [],
      tabActive: "",
      tablePrescription: [],
      prescription: {},
      PriceInfo: "",
      drugFormData: {
        currentFormName: "",
        drugCount: "",
        quantityDispensed: "",
        specifications: "",
        frequency: "",
        dosage: "",
        prescriptionWithShipment: "",
      },
      addressInfo: [],
      addressTemp: "",
      deliveryFormData: {
        receiverName: "",
        phoneNo: "",
        province: "",
        city: "",
        county: "",
        street: "",
        zipCode: "",
        remark: "",
        deliveryId: "",
      },
      pane: {},
      hasShangJiao: false,
      hasZhongJiao: false,
      hasXiaJiao: false,
      allocationQuantity: [],
      medicineFormSpecificationsQuantity: [],
      medicineFormSpecificationsDosage: [],
      medicineFormSpecificationsFrequency: [],
      PromptOnAllocationQuantity: "",
      draftInfo: {},
      addressInfoVisible: false,
      prescriptionNo: "",
      adjustmentQuantityType: "",
      specificationType: "",
      frequencyString: "",
      dosageString: "",
      isswitchList: "其他",
      // 代理商演示模式（一级/二级代理商）：开方可演示，但禁止配送下单
      isAgentDemo: false,
      // 省市区级联配置
      props: {
        lazy: true,
        value: "label",
        lazyLoad(node, resolve) {
          console.log(node);
          var nodes = [];
          if (node.level == 0) {
            for (var key in area.province_list) {
              var item = {
                label: area.province_list[key],
                value: key,
                leaf: false,
              };
              nodes.push(item);
            }
          }
          if (node.level == 1) {
            var provinceCode = node.data.value.substring(0, 2);
            for (var key in area.city_list) {
              if (provinceCode == key.substring(0, 2)) {
                var item = {
                  label: area.city_list[key],
                  value: key,
                  leaf: false,
                };
                nodes.push(item);
              }
            }
          }
          if (node.level == 2) {
            var cityCode = node.data.value.substring(0, 4);
            for (var key in area.county_list) {
              if (cityCode == key.substring(0, 4)) {
                var item = {
                  label: area.county_list[key],
                  value: key,
                  leaf: true,
                };
                nodes.push(item);
              }
            }
          }
          resolve(nodes);
        },
      },
    };
  },
  methods: {
    // 判断当前用户是否为一级/二级代理商（演示模式）
    checkAgentDemo() {
      try {
        var userInfo = this.$store.getters.getUserInfo;
        var roles = userInfo && userInfo.roles ? userInfo.roles : [];
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == "level1" || roles[i] == "level2") {
            this.isAgentDemo = true;
            return;
          }
        }
        this.isAgentDemo = false;
      } catch (e) {
        this.isAgentDemo = false;
      }
    },
    shouldShowTime(hour, minute) {
      return !(this.isEmptyValue(hour) && this.isEmptyValue(minute));
    },
    isEmptyValue(value) {
      return value === "" || value === null || value === undefined;
    },
    formatTimeValue(value) {
      if (value === "-1" || value === -1 || value === "--") {
        return "--";
      }
      return value;
    },
    handleInput(value) {
      this.drugFormData.drugCount = value.toString().replace(/\D/g, "");
      this.PriceInfoDel();
    },
    goBack() {
      this.$router.go(-1);
    },
    addressChange(e) {
      if (e.length >= 3) {
        this.deliveryFormData.province = e[0];
        this.deliveryFormData.city = e[1];
        this.deliveryFormData.county = e[2];
        this.addressTemp = "";
        this.addressInfo = e;
      }
      this.PriceInfoDel();
    },
    toAddressList() {
      var cache = {
        drugFormData: Object.assign({}, this.drugFormData),
        deliveryFormData: Object.assign({}, this.deliveryFormData),
        addressInfo: this.addressInfo ? this.addressInfo.slice() : [],
        addressTemp: this.addressTemp,
        currentForm: this.currentForm ? Object.assign({}, this.currentForm) : {},
        addressInfoVisible: this.addressInfoVisible,
        options: this.options,
        forms: this.forms,
        allocationQuantity: this.allocationQuantity,
        medicineFormSpecificationsQuantity: this.medicineFormSpecificationsQuantity,
        medicineFormSpecificationsDosage: this.medicineFormSpecificationsDosage,
        medicineFormSpecificationsFrequency: this.medicineFormSpecificationsFrequency,
        specificationType: this.specificationType,
        adjustmentQuantityType: this.adjustmentQuantityType,
        frequencyString: this.frequencyString,
        dosageString: this.dosageString,
        PromptOnAllocationQuantity: this.PromptOnAllocationQuantity,
        isswitchList: this.isswitchList,
        PriceInfo: this.PriceInfo,
        // 配送摘要与基本信息：地址簿往返后需恢复
        pane: this.pane ? Object.assign({}, this.pane) : {},
        consultInfo: this.consultInfo ? Object.assign({}, this.consultInfo) : {},
      };
      // 各子页面可能额外缓存字段，通过 _extraCache 钩子扩展
      if (this._extraCache) {
        this._extraCache(cache);
      }
      sessionStorage.setItem("fulfillmentConfirmCache", JSON.stringify(cache));
      this.$router.push({
        path: "/address",
        query: { mode: 1 },
      });
    },
    setDraftInfo() {
      this.currentForm = this.forms.find(
        (item) => item.formCode == this.draftInfo.form
      );
      this.drugFormData.currentFormName = this.currentForm.formName;
      this.drugFormData.formCode = this.currentForm.formCode;
      this.drugFormData.drugCount = this.draftInfo.formCount;
      this.deliveryFormData.receiverName = this.draftInfo.recipientName;
      this.deliveryFormData.phoneNo = this.draftInfo.recipientPhone;
      this.deliveryFormData.zipCode = this.draftInfo.zipCode;
      this.drugFormData.remark = this.draftInfo.remark;
      this.deliveryFormData.province = this.draftInfo.province;
      this.deliveryFormData.city = this.draftInfo.city;
      this.deliveryFormData.county = this.draftInfo.county;
      this.addressInfo = [
        this.draftInfo.province,
        this.draftInfo.city,
        this.draftInfo.county,
      ];
      this.deliveryFormData.street = this.draftInfo.street;
      this.addressTemp =
        this.draftInfo.province +
        "/" +
        this.draftInfo.city +
        "/" +
        this.draftInfo.county;
      this.$refs["adressCas"].panel.initStore();
    },
    generateTableData() {
      var item = this.draftInfo.prescriptionInfo;
      this.pane.count = item.count;
      this.pane.charge = item.charge;
      this.pane.totalWeight = item.totalWeight;
      this.pane.startDate = item.startDate;
      this.pane.endDate = item.endDate;
      this.pane.title = item.name;
      var itemArray = item.prescription;
      for (var j = 0; j < itemArray.length; j++) {
        var itemJ = itemArray[j];
        if (j % 2 == 1 && itemJ.key && itemJ.value !== undefined && itemJ.value !== null && itemJ.value !== "") {
          itemArray[j - 1].key1 = itemJ.key;
          itemArray[j - 1].value1 = itemJ.value;
          itemArray[j - 1].index1 = itemJ.index;
          itemArray[j - 1].visible1 = false;
        } else if (j % 2 == 1) {
          // 右侧药品无效（缺 key 或 value），不设置 key1/value1
          itemArray[j - 1].key1 = undefined;
          itemArray[j - 1].value1 = undefined;
          itemArray[j - 1].index1 = undefined;
        } else {
          itemArray[j].visible = false;
        }
      }
      var options = [];
      for (var k = 0; k < itemArray.length; k++) {
        if (k % 2 == 0) {
          options.push(itemArray[k]);
        }
      }
      this.pane.options = options;
      this.basicTableArray = this.basicTableArray.concat(
        this.draftInfo.inquiryInfo.basic_array
      );
      this.basicTableArray = this.basicTableArray.concat(
        this.draftInfo.inquiryInfo.basic_enter_array
      );
      this.basicTableArray = this.basicTableArray.concat(
        this.draftInfo.inquiryInfo.maixiang_array
      );
      this.shangjiaoTableArray = this.draftInfo.inquiryInfo.shangjiao_array;
      this.zhongjiaoTableArray = this.draftInfo.inquiryInfo.zhongjiao_array;
      this.xiajiaoTableArray = this.draftInfo.inquiryInfo.xiajiao_array;
      var that = this;
      this.shangjiaoTableArray.forEach(function (element) {
        if (element.value.length > 0) {
          that.hasShangJiao = true;
        }
      });
      this.zhongjiaoTableArray.forEach(function (element) {
        if (element.value.length > 0) {
          that.hasZhongJiao = true;
        }
      });
      this.xiajiaoTableArray.forEach(function (element) {
        if (element.value.length > 0) {
          that.hasXiaJiao = true;
        }
      });
    },
    switchList(e) {
      this.$confirm(`是否切换为${e}配送中心`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deliveryFormData.deliveryId = "";
          this.drugFormData.quantityDispensed = "";
          this.drugFormData.specifications = "";
          this.drugFormData.drugCount = "";
          this.drugFormData.dosage = "";
          this.drugFormData.frequency = "";
          this.allocationQuantity = [];
          this.medicineFormSpecificationsQuantity = [];
          this.medicineFormSpecificationsDosage = [];
          this.medicineFormSpecificationsFrequency = [];
          this.PromptOnAllocationQuantity = "";
          this.specificationType = "";
          this.adjustmentQuantityType = "";
          this.dosageString = "";
          this.frequencyString = "";
          if (e == "其他") {
            this.getAllCurrentFormCodeDeliveryDept();
            this.isswitchList = "默认";
          } else {
            this.addSelect();
            this.isswitchList = "其他";
          }
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消" });
        });
    },
    getAllCurrentFormCodeDeliveryDept() {
      this.wjtHttp.get(
        this,
        "api/delivery/getAllCurrentFormCodeDeliveryDept",
        { formCode: this.currentForm.formCode },
        null,
        (res) => {
          var data = res.data;
          this.options = data.data;
          this.PriceInfoDel();
        }
      );
    },
    PriceInfoDel() {
      this.PriceInfo = "";
    },
  },
  created() {
    this.checkAgentDemo();
  },
  destroyed() {
    this.$store.commit("updateFulfillmentConfirmData", {
      drugFormData: this.drugFormData,
      addressInfo: this.addressInfo,
      addressTemp: this.addressTemp,
      currentForm: this.currentForm,
      deliveryFormData: this.deliveryFormData,
    });
    EventBus.$off("address", null);
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "prescriptionImage") {
      this.$store.commit("updateFulfillmentConfirmData", {});
    }
    next();
  },
};
